<template>
  <div
    class="my"
    :class="{ 'my-zhiyun-version': versionConfig.ZHIYUN_VERSION }"
  >
    <div class="itemList">
      <van-card
        :desc="`用户：${userInfo.Account}`"
        :title="userInfo.Name"
        :thumb="userInfo.picUrl ? userInfo.picUrl : '/image/business.png'"
        @click="ToEdit"
      />
      <!-- <script type="text/html">
        <img src="/image/business.png" alt="">
      </script> -->
      <!-- <van-cell
        title="系统维护"
        style="border-top:0.02667rem solid #fbedf0;margin-top:0.3rem;"
        icon="van-icon van-icon-setting-o"
        to="/my/config"
        is-link
      /> -->
      <van-cell
        title="安全中心"
        is-link
        icon="van-icon van-icon-lock"
        to="/my/SecurityCenter"
      />
      <!-- <van-cell
        title="消息提醒"
        is-link
        icon="van-icon van-icon-envelop-o"
        to="/my/message"
      />
      <van-cell
        title="意见反馈"
        is-link
        icon="van-icon van-icon-records"
        to="/my/Feedback"
      /> -->
      <van-cell
        title="关于我们"
        is-link
        icon="van-icon van-icon-warning-o"
        to="/my/aboutus"
      />
      <van-cell
        title="微信消息设置"
        is-link
        icon="chat-o"
        to="/my/WechatSetting"
        style="border-bottom:0.02667rem solid #fbedf0;"
      />
    </div>
  </div>
</template>

<script>
import { Card, Cell, CellGroup } from "vant";
import { mapState } from "vuex";
import { GetUser } from "@/api/my.js";
export default {
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  data() {
    return { versionConfig, userInfo: {} };
  },
  components: {
    [Card.name]: Card,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
  },
  created() {
    GetUser({ Id: this.user.OperatorId }).then(res => {
      this.userInfo = res.Data;
    });
  },
  methods: {
    ToEdit() {},
  },
};
</script>

<style lang="less" scoped>
.my {
  width: 100%;
  .itemList {
    background-color: rgb(242, 242, 242);
    padding-bottom: 0.3rem;
  }
  /deep/.van-image__img {
    width: 1.9rem;
    height: 1.9rem;
    border-radius: 50%;
    padding: 5px;
    border: 5px solid rgba(30, 150, 243, 0.5);
    object-fit: cover !important;
    margin-top: 0.2rem;
  }
  .van-card__content {
    color: white;
    top: 0.7rem;
    left: -0.3rem;
    .van-card__title {
      line-height: 0.5rem;
      font-size: 0.5rem;
      font-weight: 600;
    }
    .van-card__desc {
      margin-top: 0.1rem;
      color: white;
    }
  }
  .van-cell {
    font-size: 0.4rem;
    padding: 0.4rem;
  }
  .van-card {
    background-color: rgb(6, 193, 174);
  }
  .van-icon-records {
    color: rgb(58, 210, 178);
  }
  .van-icon-warning-o {
    color: rgb(155, 188, 31);
  }
  .van-icon-envelop-o {
    color: rgb(65, 171, 227);
  }
  .van-icon-lock {
    color: rgb(239, 121, 25);
  }
  .van-icon-setting-o {
    color: rgb(103, 135, 231);
  }
}
.my-zhiyun-version {
  &.my .van-card {
    background-color: #4b77b2;
  }
}
</style>
